import type { IdTaskDto, TaskDto } from '@/services/ws-funnel/src/main/resources/rest-api';

export const selectTaskId = (task: TaskDto): IdTaskDto => task.id!;
